module.exports = __webpack_public_path__ + "media/boschautoparts/logo-dc82f700.png";